var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToothDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 413.4 665.9",
    style: {
      enableBackground: "new 0 0 413.4 665.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{font-family:'Arial-Black';}\n\t.st2{font-size:24px;}\n\t.st3{font-size:24.0033px;}\n\t.st4{font-size:23.9976px;}\n\t.st5{fill:none;stroke:#000000;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#000000;}\n\t.st7{fill:none;stroke:#000000;stroke-linecap:round;}\n\t.st8{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Labels"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 530.3,
    transform: "matrix(0.7161 -0.698 0.698 0.7161 -412.3453 225.5525)",
    className: "st0",
    width: 24.2,
    height: 178.8
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.698 0.7161 -0.7161 0.698 39.7344 605.1)",
    className: "st1 st2"
  }, "LR"), /*#__PURE__*/React.createElement("rect", {
    x: 263.8,
    y: 598.7,
    transform: "matrix(0.6988 -0.7153 0.7153 0.6988 -330.5094 436.6105)",
    className: "st0",
    width: 178.8,
    height: 24.2
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.6988 -0.7153 0.7153 0.6988 344.2849 629.6003)",
    className: "st1 st2"
  }, "LL"), /*#__PURE__*/React.createElement("rect", {
    x: -35.5,
    y: 56.4,
    transform: "matrix(0.5753 -0.818 0.818 0.5753 -33.174 73.1667)",
    className: "st0",
    width: 178.8,
    height: 24.2
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.5753 -0.818 0.818 0.5753 34.0946 107.6994)",
    className: "st1 st3"
  }, "UR"), /*#__PURE__*/React.createElement("rect", {
    x: 358.3,
    y: 1.9,
    transform: "matrix(0.8234 -0.5674 0.5674 0.8234 13.5996 226.2936)",
    className: "st0",
    width: 24.2,
    height: 178.8
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.5674 0.8234 -0.8234 0.5674 350.9837 74.0922)",
    className: "st1 st4"
  }, "UL"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Teeth"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UL8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4278_2_",
    className: "st5",
    d: "M378,278.7c-8.3,0.2-15.8,1.7-21.1,5.9c-7.4,3.2-12.2,6.8-12.1,11.1 c-2.7,6.3-1.2,11.1-0.2,16l3.3,8.2c2.1,4.8,6.9,8.2,14.6,10.1c9.1,2.1,18.1,4.5,27.6-0.2c10.7-3.2,11.5-8.7,12.8-14.1 c3.4-5.4,5.9-12,5.3-22.4c-0.8-4.8-1.8-10.9-8.3-14.1S387.3,277.1,378,278.7L378,278.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4280_2_",
    className: "st6",
    d: "M402,288.7c7,11.3,1.4,15.8-2.1,21.4c0.3,9.8-0.5,17.3-7,16c-10.2,6.3-17.1,2.2-24.8,0.6 c-1-1.8-0.9-4.1-4-5.1c0,0-5.9-15.1-6.7-17.4c-0.7-2.3-1.2-6.6,3.7-10.9c0,0,7.6-7,12.3-8.8c2.2-0.9,4.8-0.4,7.1-0.8 c4.8-0.8,14.4-3.2,14.4-3.2C399.5,279.7,402.2,282.2,402,288.7L402,288.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4282_2_",
    className: "st7",
    d: "M368.7,316.3c-0.3-0.2,5.1-3.2,8.8-4.3c1.9-0.6,3.1-2.7,3.7-4.6c1.2-3.9-2.3-9.2-0.9-12.2 c1.4-3.1,4-3,6.3-3.9c1.6-0.6,2.4,0,4.9-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4286_2_",
    className: "st7",
    d: "M390,309.1c-1.3-0.7-2.9-1.6-5-1.1s-3.2,0.6-3.8-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4288_2_",
    className: "st7",
    d: "M372.5,306.8c3,0.1,6.2,2.1,9-1.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4290_2_",
    className: "st7",
    d: "M398.5,249.7c2.9-4,2.5-9.7,0.6-16.4c-7.5-17.1-20.8-20.8-41.7-7.6 c-6.5,2.6-11.7,7.7-15.1,12.8c-3.4,5-6.5,7.4-4.8,16.2c3.8,14.9,10.4,26.5,29.2,24.2c7.5-0.9,14,1,23.5-6.3 C393.7,266.5,400.7,266.9,398.5,249.7L398.5,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4292_2_",
    className: "st6",
    d: "M389.9,227.6c-7.8-17-20.7-3.5-33.2,7.8c-2.6,3.1-5.8,5-6.9,10.5c-3.8,9.8,5.7,15.3,10.2,22 s9.1,10,17.2,7.4c19-7,19.7-16.1,16.7-25.7c6-14.2,1.9-15,0.4-19C392.9,229.8,391.4,229.4,389.9,227.6L389.9,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4294_2_",
    className: "st7",
    d: "M359.8,235.6c1.9,1,3.3,1,4.7,1c3.7-0.5,5.2,1.4,5.7,4.6c0,2-0.5,4.3,2.6,5.3 c2.7,2.5,1.4,3.6,1,5.1c0.1,2.3,0.1,3.8,0.2,5.1c0.1,8.2-2.2,8.1-3.6,10.9c-0.9,0.9-1.9,1.8-1.2,3.2l-1.6,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4298_2_",
    className: "st7",
    d: "M386.7,229.3c-2.7,0.1-5.5,0.2-6.1,2.4c-3.5,2.6-6.9,5.1-10.7,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4300_2_",
    className: "st7",
    d: "M391.8,247.7l-7.9,1c-3,1.3-6.1,2.1-10.1,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4304_2_",
    className: "st7",
    d: "M373.8,252.4l-4.3-0.4c-1.9,1.3-3.8,2.1-5.7,2.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4306_2_",
    className: "st6",
    d: "M379,166.7c-14.2-12.3-24.7-5.2-35.2,1.9c-2.8,3.5-5.6,7-9.5,10.5 c-11.9,11.4-9.6,19.2-2.8,25.7c4.3,4.8,8.4,9.4,10.6,13.1c2.5,2.6,4.8,4.5,6.7,5.4c9.2,4.1,12.7-1.6,17.8-4.5 c18.5-9.7,25.1-23.3,20.3-40.5C386.4,171.8,383.3,168.5,379,166.7L379,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4308_2_",
    className: "st6",
    d: "M376.8,181.7c3-13.9-4.2-12.3-8.1-15.8c-6.8-1.6-12.5-5.6-23.9,2.5 c-8.5,11.8-5.9,18.4-7,26.7c-0.5,7.9,1.9,12.8,5.1,14.8c0.8,4.3,0.6,8.4,7.7,12.1c6,5.4,10.3,0.8,14.8-2.7 c6.7-1.8,7.8-6.2,7.7-12.4C386.7,201.1,379.1,189.8,376.8,181.7L376.8,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4310_2_",
    className: "st7",
    d: "M350.3,168.8c1.4,1.6,3.3,1.9,3.7,6.5c-0.6,4.7,2,9.4,4.5,14.2c2.6,2.5,1.8,9.4,2.5,14.4 c-2.6,2.4-5.1,2.5-7.7,2.2l-4.8,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4312_2_",
    className: "st7",
    d: "M374.2,183.6c-1.7,1.9-3,4.1-7.9,3.9c-2.8-0.4-5.5-0.5-8.3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4314_2_",
    className: "st7",
    d: "M343.7,185.3c5.3,0.9,13.1,0.5,14.6,3.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4320_2_",
    className: "st7",
    d: "M350.6,124.1c14,2,20.7,9.2,16.5,24.2c-4.5,5.5-8.6,11.4-16.2,13.8 c-2.7-0.1-5.1,0.2-6.7,1.2c-2.3,0.6-5,0.6-7.9,0.2c-5.4-2.9-12.7-0.5-15.8-10.1c-2.5-7.7-2.1-14.4,4-19.4 C336.5,124,343.2,124.9,350.6,124.1L350.6,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4322_2_",
    className: "st7",
    d: "M347.1,125.1c1.8,2.1,3.4,4,2.8,6.2c0.8,2.6,0.8,3.3,0.9,4.3c1.1,2,1.2,2.6,1.2,3 c0,3.5-0.6,4.3-1.2,5.3c-1.6,4.7-0.1,5.7,0.8,7.3c1,1.6,2.3,0.8,2.8,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4324_2_",
    className: "st7",
    d: "M336.7,157.3c6.8-2.4,7.3-6,6-9.9c0.7-6.4-1.9-10-3.7-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4326_2_",
    className: "st7",
    d: "M332.8,135.9c2.8,0.3,5.7,0.4,8.5,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4328_2_",
    className: "st7",
    d: "M345.9,131.8c-3.1,2.7-4.1,4.8-5,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4330_2_",
    className: "st7",
    d: "M350.5,156.7c-1.3-1.3-3.7-3.3-7.7-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4346_2_",
    className: "st7",
    d: "M339.7,162c-5.4-3.6-12.5-0.6-14.9-11.6c-0.4-3.5-2.8-7.7,2.7-15.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4332_2_",
    className: "st7",
    d: "M339.2,84.9c11.7,4.1,12.5,9.7,12.6,15.4c0.6,25.2-20.8,24.8-25,22.9 c-6.5,0.8-11.1,0.1-14.6-1.4c-6.7-0.5-9.9-4.5-10.9-10.6c-1-3.3-1.3-6.9,0.3-11.5c1.2-2.6,0.4-5,7.8-7.9c7.8-0.9,10.3-2.8,13.5-5 C327.5,81.6,333.3,82.7,339.2,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4334_2_",
    className: "st7",
    d: "M328.1,84.9c-0.1,1.2-1,2.5,2.1,3.7c5.3,4.3,5,7.5,3.7,10.5c-2.5,4.7-1.6,6.9,0.9,7.9 c7.7,7.4,5.9,9,8,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4336_2_",
    className: "st7",
    d: "M337.6,116.1c-7.2-1-12.9-3.8-14.5-12.1c-0.8-4.8,1.9-7.5,5.7-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4338_2_",
    className: "st7",
    d: "M311.6,96.7c9.4,0.9,12.4,3.3,11.2,6.3c0,7.8-2.4,5.9-4.2,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4340_2_",
    className: "st7",
    d: "M327.2,116.6c-1.3-1.7-0.9-3.5-0.3-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4344_2_",
    className: "st7",
    d: "M308.7,93.7c-2.3,5.1,0,9.3-0.5,13c-0.4,5.2,1.1,9.5,6.6,12.4c3.4,1.9,7.5,2.3,11.2,2.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4348_2_",
    className: "st7",
    d: "M318.8,85.7c7.7-2.9,11.1-7.7,11.7-14c0.7-6.1-0.5-12-4.4-17.6c-3.5-8.8-6.7-8.2-9.9-8.7 c-2.8,0.5-5.4,0.4-7.9,0.2c-7.6-0.1-10.3,3.5-12.1,5.8c-6.1,8.8-5.2,13.8-6.6,20c-0.6,6.8,0,12.6,3.6,15.6 c10.8,7.5,12.5,3.6,16.8,3.1C318.2,86.4,316.1,87.1,318.8,85.7L318.8,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4350_2_",
    className: "st7",
    d: "M323.3,76.8c-0.7-8.4-1.6-16.3-5.7-20c-4-3.9-9.1-6.7-16-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4352_2_",
    className: "st7",
    d: "M298.6,56.7c-4,18.2-5.9,22.6,5.9,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4354_2_",
    className: "st7",
    d: "M310,73.8c-9.8,12.7-3.1,10.7,7.7,4.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4356_2_",
    className: "st7",
    d: "M294,35.1c-19.2-12.6-15.2-8.9-23.4-11.7c-2.9-1-5.2-1.2-6.4,0.8l-4.4,4.5 c-3,3.8-2.8,4.6-3.2,6c-1.4,11.7,0.2,11.6,0.5,16.6c2.2,4.3,4.8,8.1,9.3,10c2.8,1.9,6.6,1.8,10.7,1.1l6.7-1.6 c2.6,0.4,4.9-1.4,7.2-2.9c4.8-3.4,6.1-8.2,7.8-12.9c0.3-3-0.5-5.7-2.5-8L294,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4358_2_",
    className: "st7",
    d: "M288.6,56.4c2.6-4,6.7-7.2,1.7-15c-4.6-3.6-8.2-4.7-12.2-6.8c-3.4-1.7-6.8-3.4-9.3-3.2 c-10.2-1-6,1.5-8.8,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4360_2_",
    className: "st7",
    d: "M267.1,38.4c-0.9,4.6-1.7,9.3-4.2,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4362_2_",
    className: "st7",
    d: "M273,57.4c-0.4-3.9,5.3-5.6,10-7.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4364_2_",
    className: "st7",
    d: "M256.6,27.4c-0.1,0.9-5.1,9.8-6.4,13.8c-1.7,4.3-4.5,8.3-11.7,10.3c-5.9-0.7-12-0.9-17-8 l-12.3-18.7l-2.2-5.9c-1.6-4.3,1.9-8.2,5.2-9.9l8.9-2.4c5.2-0.3,8.7-1.9,18.8,1.2l9.5,2.1c3.5,1.5,8.1,0.9,8.2,8.6 C257.4,21.4,258.5,24.1,256.6,27.4L256.6,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4366_2_",
    className: "st7",
    d: "M247.4,38.8l2.2-18.2c-1.2,0,1.3-3.7-3.1-5.3c-16.2-6.3-25.6-1.7-28.2-0.3 c-2.6,1.4-4.9,5.2-4.4,9.2s1.6,4.9,2.4,6.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3908_2_",
    className: "st7",
    d: "M154.5,27.3c0.1,0.9,5.1,9.8,6.4,13.8c1.7,4.3,4.5,8.3,11.7,10.3c5.9-0.7,12-0.9,17-8 l12.3-18.7l2.2-5.9c1.6-4.3-1.9-8.2-5.2-9.9L190,6.5c-5.2-0.3-8.7-1.9-18.8,1.2l-9.5,2.1c-3.5,1.5-8.1,0.9-8.2,8.6 C153.8,21.3,152.6,24,154.5,27.3L154.5,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3910_2_",
    className: "st7",
    d: "M163.7,38.7l-2.2-18.2c1.2,0-1.3-3.7,3.1-5.3c16.2-6.3,25.6-1.7,28.2-0.3 c2.6,1.4,4.9,5.2,4.4,9.2s-1.6,4.9-2.4,6.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3900_2_",
    className: "st7",
    d: "M117.1,35c19.2-12.6,15.2-8.9,23.4-11.7c2.9-1,5.2-1.2,6.4,0.8l4.4,4.5c3,3.8,2.8,4.6,3.2,6 c1.4,11.7-0.2,11.6-0.5,16.6c-2.2,4.3-4.8,8.1-9.3,10c-2.8,1.9-6.6,1.8-10.7,1.1l-6.7-1.6c-2.6,0.4-4.9-1.4-7.2-2.9 c-4.8-3.4-6.1-8.2-7.8-12.9c-0.3-3,0.5-5.7,2.5-8L117.1,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3902_2_",
    className: "st7",
    d: "M122.5,56.3c-2.6-4-6.7-7.2-1.7-15c4.6-3.6,8.2-4.7,12.2-6.8c3.4-1.7,6.8-3.4,9.3-3.2 c10.2-1,6,1.5,8.8,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3904_2_",
    className: "st7",
    d: "M144,38.3c0.9,4.6,1.7,9.3,4.2,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3906_2_",
    className: "st7",
    d: "M138.1,57.3c0.4-3.9-5.3-5.6-10-7.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3892_2_",
    className: "st7",
    d: "M92.9,86c-7.8-2.6-11.4-7.3-12.2-13.5c-1-6.1,0.1-12,3.8-17.7c3.2-8.9,6.4-8.4,9.6-9 c2.8,0.4,5.4,0.2,7.9-0.1c7.6-0.3,10.4,3.1,12.2,5.4c6.4,8.6,5.7,13.6,7.3,19.7c0.8,6.8,0.4,12.6-3,15.7 c-10.5,7.9-12.3,4-16.7,3.7C93.5,86.6,95.6,87.2,92.9,86L92.9,86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3894_2_",
    className: "st7",
    d: "M88.1,77.2c0.4-8.4,1.1-16.3,5-20.2c3.9-4.1,8.9-7,15.8-8.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3896_2_",
    className: "st7",
    d: "M112.1,56.3c4.6,18.1,6.7,22.3-5.5,11.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3898_2_",
    className: "st7",
    d: "M101.3,73.7c10.2,12.4,3.4,10.5-7.6,5.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3876_2_",
    className: "st7",
    d: "M71.9,84.8c-11.7,4.1-12.5,9.7-12.6,15.4c-0.6,25.2,20.8,24.8,25,22.9 c6.5,0.8,11.1,0.1,14.6-1.4c6.7-0.5,9.9-4.5,10.9-10.6c1-3.3,1.3-6.9-0.3-11.5c-1.2-2.6-0.4-5-7.8-7.9c-7.8-0.9-10.3-2.8-13.5-5 C83.6,81.5,77.8,82.6,71.9,84.8L71.9,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3878_2_",
    className: "st7",
    d: "M83,84.8c0.1,1.2,1,2.5-2.1,3.7c-5.3,4.3-5,7.5-3.7,10.5c2.5,4.7,1.6,6.9-0.9,7.9 c-7.7,7.4-5.9,9-8,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3880_2_",
    className: "st7",
    d: "M73.5,116c7.2-1,12.9-3.8,14.5-12.1c0.8-4.8-1.9-7.5-5.7-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3882_2_",
    className: "st7",
    d: "M99.5,96.6c-9.4,0.9-12.4,3.3-11.2,6.3c0,7.8,2.4,5.9,4.2,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3884_2_",
    className: "st7",
    d: "M83.9,116.5c1.3-1.7,0.9-3.5,0.3-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3886_2_",
    className: "st7",
    d: "M91.7,94.4c-3.3,3-3.6,4.5-3.6,5.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3888_2_",
    className: "st7",
    d: "M102.5,93.7c2.3,5.1,0,9.3,0.5,13c0.4,5.2-1.1,9.5-6.6,12.4c-3.4,1.9-7.5,2.3-11.2,2.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3063_2_",
    className: "st7",
    d: "M60.5,124c-14,2-20.7,9.2-16.5,24.2c4.5,5.5,8.6,11.4,16.2,13.8c2.7-0.1,5.1,0.2,6.7,1.2 c2.3,0.6,5,0.6,7.9,0.2c5.4-2.9,12.7-0.5,15.8-10.1c2.5-7.7,2.1-14.4-4-19.4C74.6,124,68,124.8,60.5,124z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3065_2_",
    className: "st7",
    d: "M64,125.1c-1.8,2.1-3.4,4-2.8,6.2c-0.8,2.6-0.8,3.3-0.9,4.3c-1.1,2-1.2,2.6-1.2,3 c0,3.5,0.6,4.3,1.2,5.3c1.6,4.7,0.1,5.7-0.8,7.3c-1,1.6-2.3,0.8-2.8,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3067_2_",
    className: "st7",
    d: "M74.4,157.3c-6.8-2.4-7.3-6-6-9.9c-0.7-6.4,1.9-10,3.7-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3069_2_",
    className: "st7",
    d: "M78.3,135.8c-2.8,0.3-5.7,0.4-8.5,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3071_2_",
    className: "st7",
    d: "M65.2,131.8c3.1,2.7,4.1,4.8,5,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3073_2_",
    className: "st7",
    d: "M60.7,156.6c1.3-1.3,3.7-3.3,7.7-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3890_2_",
    className: "st7",
    d: "M71.4,162c5.4-3.6,12.5-0.6,14.9-11.6c0.4-3.5,2.8-7.7-2.7-15.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5187_2_",
    className: "st6",
    d: "M32.1,166.7c14.2-12.3,24.7-5.2,35.2,1.9c2.8,3.5,5.6,7,9.5,10.5 c11.9,11.4,9.6,19.2,2.8,25.7c-4.3,4.8-8.4,9.4-10.6,13.1c-2.5,2.6-4.8,4.5-6.7,5.4c-9.2,4.1-12.7-1.6-17.8-4.5 c-18.5-9.7-25.1-23.3-20.3-40.5C24.7,171.7,27.8,168.5,32.1,166.7L32.1,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5189_2_",
    className: "st6",
    d: "M34.3,181.7c-3-13.9,4.2-12.3,8.1-15.8c6.8-1.6,12.5-5.6,23.9,2.5c8.5,11.8,5.9,18.4,7,26.7 c0.5,7.9-1.9,12.8-5.1,14.8c-0.8,4.3-0.6,8.4-7.7,12.1c-6,5.4-10.3,0.8-14.8-2.7c-6.7-1.8-7.8-6.2-7.7-12.4 C24.4,201,32,189.8,34.3,181.7L34.3,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5191_2_",
    className: "st7",
    d: "M60.8,168.8c-1.4,1.6-3.3,1.9-3.7,6.5c0.6,4.7-2,9.4-4.5,14.2c-2.6,2.5-1.8,9.4-2.5,14.4 c2.6,2.4,5.1,2.5,7.7,2.2l4.8,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5193_2_",
    className: "st7",
    d: "M36.9,183.5c1.7,1.9,3,4.1,7.9,3.9c2.8-0.4,5.5-0.5,8.3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5195_2_",
    className: "st7",
    d: "M67.5,185.2c-5.3,0.9-13.1,0.5-14.6,3.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5171_2_",
    className: "st7",
    d: "M12.7,249.6c-2.9-4-2.5-9.7-0.6-16.4c7.5-17.1,20.8-20.8,41.7-7.6 c6.5,2.6,11.7,7.7,15.1,12.8c3.4,5,6.5,7.4,4.8,16.2c-3.8,14.9-10.4,26.5-29.2,24.2c-7.5-0.9-14,1-23.5-6.3 C17.4,266.4,10.4,266.8,12.7,249.6L12.7,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5173_2_",
    className: "st6",
    d: "M21.2,227.6c7.8-17,20.7-3.5,33.2,7.8c2.6,3.1,5.8,5,6.9,10.5c3.8,9.8-5.7,15.3-10.2,22 s-9.1,10-17.2,7.4c-19-7-19.7-16.1-16.7-25.7c-6-14.2-1.9-15-0.4-19C18.2,229.8,19.7,229.4,21.2,227.6L21.2,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5175_2_",
    className: "st7",
    d: "M51.3,235.5c-1.9,1-3.3,1-4.7,1c-3.7-0.5-5.2,1.4-5.7,4.6c0,2,0.5,4.3-2.6,5.3 c-2.7,2.5-1.4,3.6-1,5.1c-0.1,2.3-0.1,3.8-0.2,5.1c-0.1,8.2,2.2,8.1,3.6,10.9c0.9,0.9,1.9,1.8,1.2,3.2l1.6,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5181_2_",
    className: "st7",
    d: "M19.3,247.6l7.9,1c3,1.3,6.1,2.1,10.1,0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2994_2_",
    className: "st5",
    d: "M34.7,278.5c8.3,0.8,15.7,2.7,20.7,7.2c7.2,3.7,11.7,7.6,11.4,11.8c2.3,6.4,0.5,11.1-0.8,16 l-3.8,8c-2.4,4.6-7.4,7.7-15.2,9.1c-9.2,1.5-18.4,3.3-27.5-1.9c-10.4-3.9-10.9-9.4-11.9-14.9c-3.1-5.6-5.1-12.3-3.9-22.7 c1.1-4.8,2.5-10.8,9.2-13.6S25.5,276.4,34.7,278.5L34.7,278.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3772_2_",
    className: "st6",
    d: "M10.1,287c-7.7,10.9-2.4,15.7,0.8,21.5c-0.9,9.8-0.6,17.3,6,16.4c9.8,7,16.9,3.2,24.7,2.1 c1.1-1.8,1.2-4.1,4.3-4.8c0,0,6.8-14.7,7.7-17s1.6-6.5-3-11.1c0,0-7.1-7.5-11.7-9.5c-2.2-1-4.7-0.7-7.1-1.2 c-4.8-1.1-14.2-4.1-14.2-4.1C13.1,278.2,10.4,280.5,10.1,287L10.1,287z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3774_2_",
    className: "st7",
    d: "M41.6,316.7c0.3-0.2-4.9-3.5-8.5-4.9c-1.9-0.7-3-2.9-3.4-4.9c-1-4,2.9-9,1.7-12.1 s-3.8-3.3-6.1-4.3c-1.5-0.7-2.4-0.1-4.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3776_2_",
    className: "st8",
    d: "M38.7,291.1c-3.2,0.9-7.3,1.8-7.5,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3778_2_",
    className: "st7",
    d: "M20.8,308.1c1.3-0.7,3-1.4,5.1-0.8s3.2,0.8,3.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3780_2_",
    className: "st7",
    d: "M38.4,306.9c-3-0.1-6.4,1.7-8.9-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4179_2_",
    className: "st7",
    d: "M31.5,288.7c0.7,1.8,1.1,3.6-0.2,5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3912_2_",
    className: "st6",
    d: "M13.1,389.8c-0.8-5.4-4.2-5.9-1.4-17.7c1.4-8.4,5.6-15.4,14.9-19.5c5.7-0.8,10.8-4.8,17.3,0 c1.9,1.7,3.3,2.6,4.6,3.2c2.6,2.7,7.6,2.9,10.1,13.2c0,3.9-1,5.4,0.8,13.9c0.6,3.3,2.2,5.3,0.3,11.3c-2,2.8-1.8,5.7-8.1,8.2 c-1.7,1.6-15.3,3.1-19.7,2.9s-4.2,1.4-10.9-5C18.5,396.9,16.1,395.5,13.1,389.8L13.1,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3914_2_",
    className: "st6",
    d: "M44.3,356.8c-5-7.5-10.6-4.2-16.4,1.1c-3.2,3.9-4.3,8-3.9,12.3c0.1,2.5,1.2,4.3,3.7,4.8 c-1.6,0.9-2.3,2.6-2.2,4.8l2.2,12.9c2.1,5.3,3.8,5.3,5.6,7c1,0.5,1.9,1,3.2,1.1c1.8-0.6,3.6-1,5.3-6.1c-1.5-0.5,4.8-2.9,0.1-7.7 c-1.5-1.6,3.5-6.9,0.6-11.3c-1.5-4.8-2.9-8.9-4.1-10.8c3.1-0.5,2.2-3.4,3.2-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3916_2_",
    className: "st6",
    d: "M34.9,364l3.7,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3920_2_",
    className: "st6",
    d: "M49.5,374.8c-2,0.9-3.7,2.4-6.6,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3922_2_",
    className: "st6",
    d: "M37.4,390.6c2.3-0.4,4-1.5,4.7-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3924_2_",
    className: "st6",
    d: "M33.1,374.9c3.1-0.6,6.5-2.4,8.9-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3926_2_",
    className: "st6",
    d: "M42.8,399.2c2-0.1,3.8,0.1,6.1-0.6c3.2-3.6,4.4-3.6,6.5-5.2c0.4-0.1,4.5-4.4,1.5-10.8 c-1.6-3.3-2-4.4-1.3-6.8c-1.6-5.6-0.7-6.9-1.1-10.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3928_2_",
    className: "st6",
    d: "M30.4,406c-4.6,2.1-9.3,3.5-13.6,8.1c-3.6,2.8-6.2,7.9-6.9,17.9c-0.3,7.1-2,14,2.7,21.7 c4,3.4,1.6,4.5,12.5,10.3c5.6,2.4,9.7,7.6,18.3,4.5c4.2-1.2,5.6-0.7,12.8-3.7c3-0.7,5.6-2.4,7-6.4c1.5-2.6,2.8-6.2,3.6-11.4 c-0.3-4.5-1-6.4-1.6-8.7c-1-6.1-0.6-8.6,0-10.4c0.1-3.1-0.5-6.1-2.5-9.2c-1-3.3-1.7-6.4-7.5-10.1C49.8,404.8,46.4,401.7,30.4,406 L30.4,406z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3930_2_",
    className: "st6",
    d: "M40.6,464.3c2.1-1,2.1-2.7,8.4-2.2c1.5-0.2,3.1-0.2,4.6-2.3l3.3-2.1l2.9-2.5 c2.2-2.4,2.7-5,2-7.8c-0.4-3.1-1-6.8-0.5-7.3c0.3-1.9-0.3-5-1-8.2c0.3-4.1,3.2-3.6-0.6-15.1c-0.2-2.5-1.6-3.7-4-3.7 c-2-0.4-2.5-1.3-4.9-3.2c-1.8-1-2.7-2.1-6.6-3.1c-3,0.4-5.9-0.6-8.9,1.8l-5.2,4.7c-4.2,3.5-4.7,5.4-5,7.3 c-1.2,2.8-0.7,5.6-0.3,8.4c0.1,2.4,0.9,4.4,3.3,5.5c-1.2,1.4-2.5,2-3,6.6c-1.2,7.8,0.7,9.9,1.9,13c2.5,3.6,5,6.4,7.5,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3932_2_",
    className: "st6",
    d: "M47.5,414.9c-2.3,1.5-4,3.9-5,7.8c0.4,3,1.1,5.4,1.8,7.8c0.6,3.3,2.3,3.1,1.5,11 c-1.5,1.5-1.9,2.6-1.5,3.5c2.8,6,1.8,11.2-2.6,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3934_2_",
    className: "st6",
    d: "M51.7,453.7c-1.4-3-2.9-5.9-6.9-7.6c-0.5-1.7-2.4-2.4-5.9-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3936_2_",
    className: "st6",
    d: "M33.2,433.9c5.6-0.5,10.6-0.5,12.3,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3938_2_",
    className: "st6",
    d: "M59.6,437.3c-4.4-1.2-7.4-3.6-14.2-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3940_2_",
    className: "st6",
    d: "M58,431.8l-6.1,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3942_2_",
    className: "st6",
    d: "M33.7,420.2c4,0.8,6.9,1.6,8.9,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3944_2_",
    className: "st6",
    d: "M39.1,412.9c1.6,3.1,3.6,6.3,3.3,9.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3946_2_",
    className: "st6",
    d: "M60,467.9c2.9-0.9,6.1,0.8,9.3,2.9l4.3,5c3,2.9,4.3,5.8,4.1,8.7c-0.3,5,1.1,10.1,4.4,15.1 c2.1,6.2,3.5,12.2-0.2,16.7c-2.3,4.1-5,8.1-10.6,10.9c-5.8,2.4-10.9,5.6-17.9,6.5c-4.6,0.4-8.3,1.9-15.6-1.5l-10-6.7 c-1.7-1.2-3.3-1.9-5.9-9.6c-0.9-7.1-4.2-13.9-0.2-21.6l6.4-14.6c3-3.8,5-7.9,11.4-10.4c3.7-1.2,6.3-3.1,13.4-2.4L60,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3948_2_",
    className: "st6",
    d: "M70.1,474.8c1.5,3.2,3.9,6.4,3.9,9.5c0.8,6.4,2.8,10.9,4.9,15.4c1.2,3.1,3.1,5.4,1.5,12 c-1.2,4.1-2.2,8.3-8.2,10.1l-10.3,4.6c-2.9,1.4-6.9,1.2-11.1,0.6c-4.1-1.5-8.3-1.4-12.4-7.2c-0.9-1.7-1.4-4.2-1-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3950_2_",
    className: "st6",
    d: "M35.5,508.1c-2,0-3.5-0.6-3.2-4.2c0.5-6.8-0.5-13.7,3-20.2c0-3.8-0.2-7.7,2.6-9.5 c3.8-2.8,5.6-7.5,13.6-6c4,0.9,6.6,0.9,7.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3952_2_",
    className: "st6",
    d: "M59.2,475.5c-1.5,3.7-2.4,7.2-6,11.8c1.5,4.8,3.6,6.6,5.7,8.2c0.5,1.4,1.4,0.7,1,7.9 c0.5,6.9,5,9.3,7.6,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3954_2_",
    className: "st6",
    d: "M44,506.5c5.2-2.5,10.4-5.9,15.6-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3956_2_",
    className: "st6",
    d: "M72.7,492.1c-3.8,5.9-8.5,5.5-12.9,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3958_2_",
    className: "st6",
    d: "M65,484c-3.1,3.5-6.1,6.9-6,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3960_2_",
    className: "st6",
    d: "M38,481.3c3.5,4.2,8.4,6.5,15.2,6.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3962_2_",
    className: "st6",
    d: "M82,531.7c12.2,6,12,9.3,12.3,13.9c-0.9,5.5-0.7,7.6-0.6,10.3c0.2,5.7-3.4,7.2-5.6,10.1 c-7.1,7.1-11,4.8-16,6c-4.6-0.7-7.5-1.4-10.2-2.1c-7.6-1.8-6.9-4.7-9.8-7.1c-3.7-4.9-4-11.2-2.1-18.5c1.6-4.3,4.8-7.5,8.2-10.6 l8.3-4.2C73,526.9,80.3,530.6,82,531.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3964_2_",
    className: "st6",
    d: "M70.6,531.3c-2.6,0.5-5.9,0.9-7,6.8c0,2.6-0.8,4.5-1.8,6.4c-1.2,6.1,1.9,10.2,4.5,14.4 c2.1,3.5,4.7,3.9,7.2,4.7c2.7,1.4,4.8,0.5,6.2-2.7c0.9-1.8,1-4.5,3.1-4.8c0.9-1.6,1.1-3,1-4.3c-1.2-2.2-0.2-5.2,0.1-8.1 c-4.8-0.2-6-4.1-6.5-8.6C75.3,534.3,73.1,534,70.6,531.3L70.6,531.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3966_2_",
    className: "st6",
    d: "M76.4,558.3c2.9-2.6,2.8-7.1,2.8-11.6c-1.8-7.6-4.9-11.2-10-9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3968_2_",
    className: "st6",
    d: "M81.8,553.5c-0.2-3.9-1.4-5.6-3-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3970_2_",
    className: "st6",
    d: "M74.7,534.9l0.4,3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3870_2_",
    className: "st6",
    d: "M79.9,574.7c-4.8,6.6-6,11.4-5.5,15.3c1.4,6.8,2.2,14.2,9.4,16.9 c11.5,3.8,13.9,0.6,18.6-0.8c5.3-2.6,9.5-5.8,12.5-9.8c2.3-1.6,2.1-3.2,2.2-4.8c-0.4-3,0.3-5,0.5-7.4c0.4-4.7-1.7-8-2.8-11.8 c-3.4-2.8-5.9-6.5-11.4-6.8l-9.5-0.3C88,564.9,84,570,79.9,574.7L79.9,574.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3872_2_",
    className: "st6",
    d: "M82.4,576.1c1.7,2.4,3.8,5.2,4.9,6.7c0.6,1.1,0.1,1.8,0.2,3.5c-0.7,4.3,0.6,4,1.8,5 c1.2,1,2.5,1.9,3.5,3.5c1.1,3.2,2.6,2.5,4,3l5.7,1c4.5,1.4,5.2-0.7,7.7-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3877_2_",
    className: "st6",
    d: "M96.6,592.4l10.6-12.6c2.2-2.7,3.9-3.3,4.1,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3879_2_",
    className: "st6",
    d: "M94.9,581.2c1-3.2,3.9-6.3,8.9-9.5c-1.9,0.7-3.9,1.4-6.4,0.1c-3.1-1.5-4.5,0.2-6.3,1.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3881_2_",
    className: "st6",
    d: "M120.3,597.8c8.3-1.2,15.5-1.2,17,5.1l4.2,12.4c3,9.4-0.2,7.5-0.6,10.5l-6.2,7.3 c-2.4,2.4-4.9,4.7-10.5,4.8c-8.2-0.3-16.5-0.4-18.3-12.3l-0.7-13.9C106.8,605.2,108.6,598.6,120.3,597.8L120.3,597.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3883_2_",
    className: "st6",
    d: "M110.2,609c2.4,7.7,4,16.6,11.5,18c5.8,2.7,11.8,7,16.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3885_2_",
    className: "st6",
    d: "M135.6,620.9c-3,1.8-6.1,3.8-6.4-1.1c-0.5-5.2,1.7-7.6,2.6-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3887_2_",
    className: "st6",
    d: "M115.4,608.8c0.7-3.1,3-5.4,7.9-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3889_2_",
    className: "st6",
    d: "M117.9,615.8c1.7,1.6,3.4,0.3,5.1-4.7c0.9-3.8,2.5-4.8,4-6.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3891_2_",
    className: "st6",
    d: "M151.6,620.7c-3.2,4.6-12,9.2-2,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3893_2_",
    className: "st6",
    d: "M159,625.6l2.2,10.7c1.4,5.1,2.9,3,4.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3895_2_",
    className: "st6",
    d: "M140.3,629.6c0.2,3.8-0.1,7.9,4.6,8.8c4,1.4,9,2.7,10.5,4.1c6.6,3.6,7.2,1.7,9.9,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3897_2_",
    className: "st6",
    d: "M164.5,617.6c-2.4-6.6-8.1-6.6-12-3.5l-5.6,7l-6.6,6.3c-1,2.9-3.5,2.8-0.5,13.4 c1.8,5.7,5.4,8.3,9.9,9.4c5.7,1.6,10.6,0.6,15-2.1c3-3.1,7.7-4.5,6.5-11.6c-1.3-3.2-1.3-3.9-4.1-10 C166.2,623.6,165.4,622.1,164.5,617.6L164.5,617.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3899_2_",
    className: "st6",
    d: "M178.9,627.6c-1.9,4.1-3.2,8.6-6.6,11.5c-1.5,1.5-2.8,3.5-1.1,11.5c1.8,3.3,4.8,5.3,9.5,5.4 c3.8-0.7,7.1-1.7,13.1-1.2c2.9-0.7,5.5,0.2,9.1-4.4c1.2-2.2,3-3.6,0-10.9l-9-12c-2.4-1.8-2.7-4.6-8.4-5 C181,622.5,180.1,625.2,178.9,627.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3901_2_",
    className: "st6",
    d: "M173,649.5c2.5,0.4,4.8,1.2,7.6,0.4l4.5,0.4c3.1,0.5,5.8,0,8.7-0.1c4.3-0.2,8.7-0.4,7.6-3.2 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4454_2_",
    className: "st6",
    d: "M232.3,627.7c1.9,4.1,3.2,8.6,6.6,11.5c1.5,1.5,2.8,3.5,1.1,11.5c-1.8,3.3-4.8,5.3-9.5,5.4 c-3.8-0.7-7.1-1.7-13.1-1.2c-2.9-0.7-5.5,0.2-9.1-4.4c-1.2-2.2-3-3.6,0-10.9l9-12c2.4-1.8,2.7-4.6,8.4-5 C230.1,622.6,231,625.3,232.3,627.7L232.3,627.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4456_2_",
    className: "st6",
    d: "M238.1,649.6c-2.5,0.4-4.8,1.2-7.6,0.4l-4.5,0.4c-3.1,0.5-5.8,0-8.7-0.1 c-4.3-0.2-8.7-0.4-7.6-3.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4446_2_",
    className: "st6",
    d: "M259.5,620.8c3.2,4.6,12,9.2,2,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4448_2_",
    className: "st6",
    d: "M252.1,625.6l-2.2,10.7c-1.4,5.1-2.9,3-4.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4450_2_",
    className: "st6",
    d: "M270.8,629.7c-0.2,3.8,0.1,7.9-4.6,8.8c-4,1.4-9,2.7-10.5,4.1c-6.6,3.6-7.2,1.7-9.9,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4452_2_",
    className: "st6",
    d: "M246.6,617.7c2.4-6.6,8.1-6.6,12-3.5l5.6,7l6.6,6.3c1,2.9,3.5,2.8,0.5,13.4 c-1.8,5.7-5.4,8.3-9.9,9.4c-5.7,1.6-10.6,0.6-15-2.1c-3-3.1-7.7-4.5-6.5-11.6c1.3-3.2,1.3-3.9,4.1-10 C244.9,623.7,245.8,622.2,246.6,617.7L246.6,617.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4436_2_",
    className: "st6",
    d: "M290.8,597.9c-8.3-1.2-15.5-1.2-17,5.1l-4.2,12.4c-3,9.4,0.2,7.5,0.6,10.5l6.2,7.3 c2.4,2.4,4.9,4.7,10.5,4.8c8.2-0.3,16.5-0.4,18.3-12.3l0.7-13.9C304.3,605.2,302.5,598.7,290.8,597.9L290.8,597.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4438_2_",
    className: "st6",
    d: "M301,609c-2.4,7.7-4,16.6-11.5,18c-5.8,2.7-11.8,7-16.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4440_2_",
    className: "st6",
    d: "M275.5,621c3,1.8,6.1,3.8,6.4-1.1c0.5-5.2-1.7-7.6-2.6-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4442_2_",
    className: "st6",
    d: "M295.8,608.9c-0.7-3.1-3-5.4-7.9-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4444_2_",
    className: "st6",
    d: "M293.2,615.9c-1.7,1.6-3.4,0.3-5.1-4.7c-0.9-3.8-2.5-4.8-4-6.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4426_2_",
    className: "st6",
    d: "M331.2,574.8c4.8,6.6,6,11.4,5.5,15.3c-1.4,6.8-2.2,14.2-9.4,16.9 c-11.5,3.8-13.9,0.6-18.6-0.8c-5.3-2.6-9.5-5.8-12.5-9.8c-2.3-1.6-2.1-3.2-2.2-4.8c0.4-3-0.3-5-0.5-7.4c-0.4-4.7,1.7-8,2.8-11.8 c3.4-2.8,5.9-6.5,11.4-6.8l9.5-0.3C323.1,564.9,327.1,570,331.2,574.8L331.2,574.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4428_2_",
    className: "st6",
    d: "M328.7,576.1c-1.7,2.4-3.8,5.2-4.9,6.7c-0.6,1.1-0.1,1.8-0.2,3.5c0.7,4.3-0.6,4-1.8,5 c-1.2,1-2.5,1.9-3.5,3.5c-1.1,3.2-2.6,2.5-4,3l-5.7,1c-4.5,1.4-5.2-0.7-7.7-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4430_2_",
    className: "st6",
    d: "M302.3,590.7c-0.3,1.6,0.8,3.5-1.6,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4432_2_",
    className: "st6",
    d: "M314.5,592.5L304,579.9c-2.2-2.7-3.9-3.3-4.1,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4434_2_",
    className: "st6",
    d: "M316.2,581.2c-1-3.2-3.9-6.3-8.9-9.5c1.9,0.7,3.9,1.4,6.4,0.1c3.1-1.5,4.5,0.2,6.3,1.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4416_2_",
    className: "st6",
    d: "M329.1,531.8c-12.2,6-12,9.3-12.3,13.9c0.9,5.5,0.7,7.6,0.6,10.3c-0.2,5.7,3.4,7.2,5.6,10.1 c7.1,7.1,11,4.8,16,6c4.6-0.7,7.5-1.4,10.2-2.1c7.6-1.8,6.9-4.7,9.8-7.1c3.7-4.9,4-11.2,2.1-18.5c-1.6-4.3-4.8-7.5-8.2-10.6 l-8.3-4.2C338.1,527,330.8,530.6,329.1,531.8L329.1,531.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4418_2_",
    className: "st6",
    d: "M340.5,531.4c2.6,0.5,5.9,0.9,7,6.8c0,2.6,0.8,4.5,1.8,6.4c1.2,6.1-1.9,10.2-4.5,14.4 c-2.1,3.5-4.7,3.9-7.2,4.7c-2.7,1.4-4.8,0.5-6.2-2.7c-0.9-1.8-1-4.5-3.1-4.8c-0.9-1.6-1.1-3-1-4.3c1.2-2.2,0.2-5.2-0.1-8.1 c4.8-0.2,6-4.1,6.5-8.6C335.8,534.4,338,534.1,340.5,531.4L340.5,531.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4420_2_",
    className: "st6",
    d: "M334.8,558.4c-2.9-2.6-2.8-7.1-2.8-11.6c1.8-7.6,4.9-11.2,10-9.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4422_2_",
    className: "st6",
    d: "M329.3,553.6c0.2-3.9,1.4-5.6,3-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4424_2_",
    className: "st6",
    d: "M336.4,535l-0.4,3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4400_2_",
    className: "st6",
    d: "M351.1,467.9c-2.9-0.9-6.1,0.8-9.3,2.9l-4.3,5c-3,2.9-4.3,5.8-4.1,8.7 c0.3,5-1.1,10.1-4.4,15.1c-2.1,6.2-3.5,12.2,0.2,16.7c2.3,4.1,5,8.1,10.6,10.9c5.8,2.4,10.9,5.6,17.9,6.5 c4.6,0.4,8.3,1.9,15.6-1.5l10-6.7c1.7-1.2,3.3-1.9,5.9-9.6c0.9-7.1,4.2-13.9,0.2-21.6l-6.4-14.6c-3-3.8-5-7.9-11.4-10.4 c-3.7-1.2-6.3-3.1-13.4-2.4L351.1,467.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4402_2_",
    className: "st6",
    d: "M341,474.9c-1.5,3.2-3.9,6.4-3.9,9.5c-0.8,6.4-2.8,10.9-4.9,15.4c-1.2,3.1-3.1,5.4-1.5,12 c1.2,4.1,2.2,8.3,8.2,10.1l10.3,4.6c2.9,1.4,6.9,1.2,11.1,0.6c4.1-1.5,8.3-1.4,12.4-7.2c0.9-1.7,1.4-4.2,1-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4404_2_",
    className: "st6",
    d: "M375.6,508.1c2,0,3.5-0.6,3.2-4.2c-0.5-6.8,0.5-13.7-3-20.2c0-3.8,0.2-7.7-2.6-9.5 c-3.8-2.8-5.6-7.5-13.6-6c-4,0.9-6.6,0.9-7.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4406_2_",
    className: "st6",
    d: "M351.9,475.6c1.5,3.7,2.4,7.2,6,11.8c-1.5,4.8-3.6,6.6-5.7,8.2c-0.5,1.4-1.4,0.7-1,7.9 c-0.5,6.9-5,9.3-7.6,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4408_2_",
    className: "st6",
    d: "M367.1,506.5c-5.2-2.5-10.4-5.9-15.6-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4410_2_",
    className: "st6",
    d: "M338.4,492.1c3.8,5.9,8.5,5.5,12.9,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4412_2_",
    className: "st6",
    d: "M346.1,484.1c3.1,3.5,6.1,6.9,6,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4414_2_",
    className: "st6",
    d: "M373.1,481.4c-3.5,4.2-8.4,6.5-15.2,6.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4382_2_",
    className: "st6",
    d: "M380.7,406.1c4.6,2.1,9.3,3.5,13.6,8.1c3.6,2.8,6.2,7.9,6.9,17.9c0.3,7.1,2,14-2.7,21.7 c-4,3.4-1.6,4.5-12.5,10.3c-5.6,2.4-9.7,7.6-18.3,4.5c-4.2-1.2-5.6-0.7-12.8-3.7c-3-0.7-5.6-2.4-7-6.4c-1.5-2.6-2.8-6.2-3.6-11.4 c0.3-4.5,1-6.4,1.6-8.7c1-6.1,0.6-8.6,0-10.4c-0.1-3.1,0.5-6.1,2.5-9.2c1-3.3,1.7-6.4,7.5-10.1 C361.3,404.8,364.7,401.8,380.7,406.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4384_2_",
    className: "st6",
    d: "M370.6,464.4c-2.1-1-2.1-2.7-8.4-2.2c-1.5-0.2-3.1-0.2-4.6-2.3l-3.3-2.1l-2.9-2.5 c-2.2-2.4-2.7-5-2-7.8c0.4-3.1,1-6.8,0.5-7.3c-0.3-1.9,0.3-5,1-8.2c-0.3-4.1-3.2-3.6,0.6-15.1c0.2-2.5,1.6-3.7,4-3.7 c2-0.4,2.5-1.3,4.9-3.2c1.8-1,2.7-2.1,6.6-3.1c3,0.4,5.9-0.6,8.9,1.8l5.2,4.7c4.2,3.5,4.7,5.4,5,7.3c1.2,2.8,0.7,5.6,0.3,8.4 c-0.1,2.4-0.9,4.4-3.3,5.5c1.2,1.4,2.5,2,3,6.6c1.2,7.8-0.7,9.9-1.9,13c-2.5,3.6-5,6.4-7.5,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4386_2_",
    className: "st6",
    d: "M363.6,415c2.3,1.5,4,3.9,5,7.8c-0.4,3-1.1,5.4-1.8,7.8c-0.6,3.3-2.3,3.1-1.5,11 c1.5,1.5,1.9,2.6,1.5,3.5c-2.8,6-1.8,11.2,2.6,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4388_2_",
    className: "st6",
    d: "M359.4,453.8c1.4-3,2.9-5.9,6.9-7.6c0.5-1.7,2.4-2.4,5.9-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4390_2_",
    className: "st6",
    d: "M377.9,433.9c-5.6-0.5-10.6-0.5-12.3,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4392_2_",
    className: "st6",
    d: "M351.5,437.3c4.4-1.2,7.4-3.6,14.2-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4394_2_",
    className: "st6",
    d: "M353.1,431.9l6.1,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4396_2_",
    className: "st6",
    d: "M377.4,420.3c-4,0.8-6.9,1.6-8.9,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4398_2_",
    className: "st6",
    d: "M372,413c-1.6,3.1-3.6,6.3-3.3,9.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4368_2_",
    className: "st6",
    d: "M398,389.9c0.8-5.4,4.2-5.9,1.4-17.7c-1.4-8.4-5.6-15.4-14.9-19.5c-5.7-0.8-10.8-4.8-17.3,0 c-1.9,1.7-3.3,2.6-4.6,3.2c-2.6,2.7-7.6,2.9-10.1,13.2c0,3.9,1,5.4-0.8,13.9c-0.6,3.3-2.2,5.3-0.3,11.3c2,2.8,1.8,5.7,8.1,8.2 c1.7,1.6,15.3,3.1,19.7,2.9c4.4-0.2,4.2,1.4,10.9-5C392.6,397,395,395.6,398,389.9L398,389.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4370_2_",
    className: "st6",
    d: "M366.8,356.9c5-7.5,10.6-4.2,16.4,1.1c3.2,3.9,4.3,8,3.9,12.3c-0.1,2.5-1.2,4.3-3.7,4.8 c1.6,0.9,2.3,2.6,2.2,4.8l-2.2,12.9c-2.1,5.3-3.8,5.3-5.6,7c-1,0.5-1.9,1-3.2,1.1c-1.8-0.6-3.6-1-5.3-6.1c1.5-0.5-4.8-2.9-0.1-7.7 c1.5-1.6-3.5-6.9-0.6-11.3c1.5-4.8,2.9-8.9,4.1-10.8c-3.1-0.5-2.2-3.4-3.2-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4372_2_",
    className: "st6",
    d: "M376.2,364.1l-3.7,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4374_2_",
    className: "st6",
    d: "M361.7,374.9c2,0.9,3.7,2.4,6.6,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4376_2_",
    className: "st6",
    d: "M373.7,390.7c-2.3-0.4-4-1.5-4.7-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4378_2_",
    className: "st6",
    d: "M378,375c-3.1-0.6-6.5-2.4-8.9-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4380_2_",
    className: "st6",
    d: "M368.3,399.3c-2-0.1-3.8,0.1-6.1-0.6c-3.2-3.6-4.4-3.6-6.5-5.2c-0.4-0.1-4.5-4.4-1.5-10.8 c1.6-3.3,2-4.4,1.3-6.8c1.6-5.6,0.7-6.9,1.1-10.3"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Brackets"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "UR8_1_",
    x: 61.9,
    y: 304.6,
    transform: "matrix(0.212 -0.9773 0.9773 0.212 -244.8682 316.7621)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR7_1_",
    x: 66.3,
    y: 255.3,
    transform: "matrix(0.3581 -0.9337 0.9337 0.3581 -193.352 240.6742)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR6_1_",
    x: 76.3,
    y: 197,
    transform: "matrix(0.3568 -0.9342 0.9342 0.3568 -132.4424 212.9533)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR5_1_",
    x: 85.3,
    y: 148,
    transform: "matrix(0.2289 -0.9735 0.9735 0.2289 -74.4162 213.2659)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR4_1_",
    x: 103.4,
    y: 111,
    transform: "matrix(0.3733 -0.9277 0.9277 0.3733 -35.8701 180.2228)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR3_1_",
    x: 114.9,
    y: 79.3,
    transform: "matrix(0.5519 -0.8339 0.8339 0.5519 -13.932 144.0118)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR2_1_",
    x: 140.7,
    y: 57.4,
    transform: "matrix(0.8202 -0.5721 0.5721 0.8202 -8.5952 98.7542)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UR1_1_",
    x: 167.3,
    y: 51.8,
    transform: "matrix(0.9996 -2.681354e-02 2.681354e-02 0.9996 -1.4759 4.8308)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL1_1_",
    x: 220,
    y: 51.8,
    transform: "matrix(0.9999 -1.707273e-02 1.707273e-02 0.9999 -0.947 3.9711)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL2_1_",
    x: 256.7,
    y: 53.3,
    transform: "matrix(0.584 -0.8118 0.8118 0.584 56.0207 240.1708)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL3_1_",
    x: 283.8,
    y: 79.2,
    transform: "matrix(0.8656 -0.5007 0.5007 0.8656 -6.8046 157.1967)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL4_1_",
    x: 294.8,
    y: 109.7,
    transform: "matrix(0.8453 -0.5343 0.5343 0.8453 -18.5884 179.3823)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL5_1_",
    x: 308.8,
    y: 141.4,
    transform: "matrix(0.976 -0.2178 0.2178 0.976 -25.8843 72.1725)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL6_1_",
    x: 314.3,
    y: 181.9,
    transform: "matrix(0.976 -0.2178 0.2178 0.976 -34.5715 74.3413)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL7_1_",
    x: 326.6,
    y: 248.8,
    transform: "matrix(0.976 -0.2178 0.2178 0.976 -48.8483 78.6256)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UL8_1_",
    x: 333.9,
    y: 298.1,
    transform: "matrix(0.976 -0.2178 0.2178 0.976 -59.408 81.4028)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR8_1_",
    x: 59.6,
    y: 364.6,
    transform: "matrix(0.9973 -7.408269e-02 7.408269e-02 0.9973 -27.7289 5.8694)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR7_1_",
    x: 65.8,
    y: 421.5,
    transform: "matrix(0.9973 -7.408269e-02 7.408269e-02 0.9973 -31.9274 6.485)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR6_1_",
    x: 78.2,
    y: 472.4,
    transform: "matrix(0.9719 -0.2354 0.2354 0.9719 -111.6948 33.3559)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR5_1_",
    x: 91.8,
    y: 528.3,
    transform: "matrix(0.9719 -0.2354 0.2354 0.9719 -124.4732 38.1239)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR4_1_",
    x: 112,
    y: 560.2,
    transform: "matrix(0.8526 -0.5225 0.5225 0.8526 -281.692 145.8055)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR3_1_",
    x: 134.7,
    y: 585.1,
    transform: "matrix(0.7376 -0.6752 0.6752 0.7376 -366.4119 251.4232)",
    width: 11.3,
    height: 24.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR2_1_",
    x: 157.1,
    y: 600.6,
    transform: "matrix(5.840509e-02 -0.9983 0.9983 5.840509e-02 -451.8961 732.228)",
    width: 10.2,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LR1_1_",
    x: 182.3,
    y: 611.4,
    transform: "matrix(5.840509e-02 -0.9983 0.9983 5.840509e-02 -438.9799 767.5933)",
    width: 10.2,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL1_1_",
    x: 218.8,
    y: 613.5,
    transform: "matrix(5.840509e-02 -0.9983 0.9983 5.840509e-02 -406.7592 805.9526)",
    width: 10.2,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL2_1_",
    x: 247,
    y: 601,
    transform: "matrix(5.840509e-02 -0.9983 0.9983 5.840509e-02 -367.6501 822.3554)",
    width: 10.2,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL3_1_",
    x: 260.7,
    y: 589.9,
    transform: "matrix(0.8459 -0.5334 0.5334 0.8459 -275.6017 237.2989)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL4_1_",
    x: 281,
    y: 564.4,
    transform: "matrix(0.6038 -0.7971 0.7971 0.6038 -338.2798 459.5292)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL5_1_",
    x: 302.4,
    y: 529.3,
    transform: "matrix(0.5171 -0.8559 0.8559 0.5171 -305.9892 527.5174)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL6_1_",
    x: 318,
    y: 481.9,
    transform: "matrix(0.3921 -0.9199 0.9199 0.3921 -247.8188 600.0166)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL7_1_",
    x: 329.1,
    y: 431.2,
    transform: "matrix(1.863020e-02 -0.9998 0.9998 1.863020e-02 -101.8906 769.8432)",
    width: 24.2,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "LL8_1_",
    x: 333.6,
    y: 368.3,
    transform: "matrix(0.1292 -0.9916 0.9916 0.1292 -69.8009 668.4775)",
    width: 24.2,
    height: 11.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Extractions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UL8_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 368.2,
    y1: 291.8,
    x2: 394.6,
    y2: 318.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 368.2,
    y1: 318.2,
    x2: 394.6,
    y2: 291.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL7_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 363.2,
    y1: 234.8,
    x2: 389.6,
    y2: 261.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 363.2,
    y1: 261.2,
    x2: 389.6,
    y2: 234.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL6_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 349.2,
    y1: 178.8,
    x2: 375.6,
    y2: 205.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 349.2,
    y1: 205.2,
    x2: 375.6,
    y2: 178.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL5_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 334.2,
    y1: 129.8,
    x2: 360.6,
    y2: 156.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 334.2,
    y1: 156.2,
    x2: 360.6,
    y2: 129.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL4_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 315.2,
    y1: 88.8,
    x2: 341.6,
    y2: 115.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 315.2,
    y1: 115.2,
    x2: 341.6,
    y2: 88.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL3_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 297.2,
    y1: 54.8,
    x2: 323.6,
    y2: 81.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 297.2,
    y1: 81.2,
    x2: 323.6,
    y2: 54.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL2_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 262.2,
    y1: 30.8,
    x2: 288.6,
    y2: 57.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 262.2,
    y1: 57.2,
    x2: 288.6,
    y2: 30.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UL1_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 220.2,
    y1: 10.8,
    x2: 246.6,
    y2: 37.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 220.2,
    y1: 37.2,
    x2: 246.6,
    y2: 10.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR1_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.2,
    y1: 12.8,
    x2: 190.6,
    y2: 39.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 164.2,
    y1: 39.2,
    x2: 190.6,
    y2: 12.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR2_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 123.2,
    y1: 31.8,
    x2: 149.6,
    y2: 58.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 123.2,
    y1: 58.2,
    x2: 149.6,
    y2: 31.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR3_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 88.2,
    y1: 54.8,
    x2: 114.6,
    y2: 81.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 88.2,
    y1: 81.2,
    x2: 114.6,
    y2: 54.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR4_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 69.2,
    y1: 92.8,
    x2: 95.6,
    y2: 119.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 69.2,
    y1: 119.2,
    x2: 95.6,
    y2: 92.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR5_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 51.2,
    y1: 129.8,
    x2: 77.6,
    y2: 156.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 51.2,
    y1: 156.2,
    x2: 77.6,
    y2: 129.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR6_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 38.2,
    y1: 175.8,
    x2: 64.6,
    y2: 202.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 38.2,
    y1: 202.2,
    x2: 64.6,
    y2: 175.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR7_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 24.2,
    y1: 235.8,
    x2: 50.6,
    y2: 262.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 24.2,
    y1: 262.2,
    x2: 50.6,
    y2: 235.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "UR8_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 18.2,
    y1: 289.8,
    x2: 44.6,
    y2: 316.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 18.2,
    y1: 316.2,
    x2: 44.6,
    y2: 289.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR8_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 28.2,
    y1: 365.8,
    x2: 54.6,
    y2: 392.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 28.2,
    y1: 392.2,
    x2: 54.6,
    y2: 365.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR7_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 31.2,
    y1: 421.8,
    x2: 57.6,
    y2: 448.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 31.2,
    y1: 448.2,
    x2: 57.6,
    y2: 421.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR6_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 44.2,
    y1: 485.8,
    x2: 70.6,
    y2: 512.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 44.2,
    y1: 512.2,
    x2: 70.6,
    y2: 485.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR5_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 64.2,
    y1: 537.8,
    x2: 90.6,
    y2: 564.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 64.2,
    y1: 564.2,
    x2: 90.6,
    y2: 537.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR4_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 83.2,
    y1: 573.8,
    x2: 109.6,
    y2: 600.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 83.2,
    y1: 600.2,
    x2: 109.6,
    y2: 573.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR3_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 109.2,
    y1: 604.8,
    x2: 135.6,
    y2: 631.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 109.2,
    y1: 631.2,
    x2: 135.6,
    y2: 604.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR2_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.2,
    y1: 620.8,
    x2: 166.6,
    y2: 647.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 140.2,
    y1: 647.2,
    x2: 166.6,
    y2: 620.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LR1_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 175.2,
    y1: 629.8,
    x2: 201.6,
    y2: 656.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 175.2,
    y1: 656.2,
    x2: 201.6,
    y2: 629.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL1_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 212.2,
    y1: 627.8,
    x2: 238.6,
    y2: 654.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 212.2,
    y1: 654.2,
    x2: 238.6,
    y2: 627.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL2_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 241.2,
    y1: 617.8,
    x2: 267.6,
    y2: 644.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 241.2,
    y1: 644.2,
    x2: 267.6,
    y2: 617.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL3_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 275.2,
    y1: 603.8,
    x2: 301.6,
    y2: 630.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 275.2,
    y1: 630.2,
    x2: 301.6,
    y2: 603.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL4_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 301.2,
    y1: 571.8,
    x2: 327.6,
    y2: 598.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 301.2,
    y1: 598.2,
    x2: 327.6,
    y2: 571.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL5_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 325.2,
    y1: 538.8,
    x2: 351.6,
    y2: 565.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 325.2,
    y1: 565.2,
    x2: 351.6,
    y2: 538.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL6_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 344.2,
    y1: 490.8,
    x2: 370.6,
    y2: 517.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 344.2,
    y1: 517.2,
    x2: 370.6,
    y2: 490.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL7_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 355.2,
    y1: 420.8,
    x2: 381.6,
    y2: 447.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 355.2,
    y1: 447.2,
    x2: 381.6,
    y2: 420.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "LL8_X"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 362.2,
    y1: 365.8,
    x2: 388.6,
    y2: 392.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 362.2,
    y1: 392.2,
    x2: 388.6,
    y2: 365.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothDiagram);
export default __webpack_public_path__ + "static/media/tooth_diagram.c3d8b02b085c2de8870169ca782e7044.svg";
export { ForwardRef as ReactComponent };